module.exports = __webpack_public_path__ + "static/media/dai.42d0a1b9.png";